<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <apexchart type="line" height="310" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  name: "GlobalCompLinear",
  data: () => ({
    series: [
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      }
    ],
    chartOptions: {
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: [
        "#A300D6",
        "#008FFB",
        "#F86624",
        "#4CAF50",
        "#e91e63",
        "#d6c51b"
      ],
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 0
      },
      stroke: {
        width: [2, 2, 2, 2, 4, 2]
      },
      title: {
        text: "Trend of confirmed cases",
        offsetY: 10,
        align: 'center',
        style: {
          fontSize: "16px",
          fontWeight: 600
        }
      },
      xaxis: {
        tickAmount: 10,
        title: {
          text: "Days since 100th confirmed case",
          offsetY: 10,
          style: {
            fontSize: "10px",
            fontWeight: 400
          }
        }
      },
      yaxis: [
        {
          min: 100,
          //max: 150000,
          tickAmount: 5,
          logarithmic: false,
          //seriesName: "Logarithmic"
          forceNiceScale: true
        }
      ]
    }
  }),
  methods: {
    loadGlobalStats(globalConfirmedData, continents) {
      //find the top confirmed globally
      var globalCounts = [];
      var SACounts = null;
      var SKoreaCounts = null;

      this.showLineGraph = false;
      this.showLogGraph = true;

      //loop through all the countries and get latest count
      //skip index 0 which is header
      for (var i = 1; i < globalConfirmedData.length; i++) {
        var cd = globalConfirmedData[i];
        var country = cd[1];

        if (country !== "South Africa") {
          var count = cd[cd.length - 1] * 1;

          globalCounts.push({ country: country, count: count, data: cd });
        } else {
          SACounts = cd;
        }

        if (country === "Korea, South") {
          SKoreaCounts = cd;
        }
      }

      //sort by count desc
      globalCounts = globalCounts.sort(function(a, b) {
        a = a.count;
        b = b.count;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //get top countries only
      globalCounts = globalCounts.slice(0, 4);

      //get the full timeseries for each country
      var ser = [];
      var maxAxis = 0;

      //loop each other country
      for (var j = 0; j < globalCounts.length; j++) {
        var vals = [];
        var dayCounter = 1;

        for (var i = 4; i < globalCounts[j].data.length; i++) {
          if (globalCounts[j].data[i] * 1 >= 100) {
            vals.push([dayCounter, globalCounts[j].data[i] * 1]);
            dayCounter += 1;
          }
        }

        ser.push({ name: globalCounts[j].country, data: vals });

        //find max count for axis
        if (j === 0) {
          maxAxis = globalCounts[j].data[globalCounts[j].data.length - 1] * 1;
        }
      }

      //get SA
      var vals = [];
      var dayCounter = 1;

      for (var i = 4; i < SACounts.length; i++) {
        if (SACounts[i] * 1 >= 100) {
          vals.push([dayCounter, SACounts[i] * 1]);
          dayCounter += 1;
        }
      }

      ser.push({ name: "SA", data: vals });

      //get South Korea
      var vals = [];
      var dayCounter = 1;

      for (var i = 4; i < SKoreaCounts.length; i++) {
        if (SKoreaCounts[i] * 1 >= 100) {
          vals.push([dayCounter, SKoreaCounts[i] * 1]);
          dayCounter += 1;
        }
      }

      ser.push({ name: "South Korea", data: vals });

      this.series = ser;
    
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        }
      })
    }
  }
};
</script>
